var stat_card_controller = {
    init: function(){
        jQuery('.pc-stat-card').find('[data-count-up-config]').each(function() {
            var $this = jQuery(this);
            var config = $this.data('count-up-config');
            var $dom = $this.find('.number');
            if (config) {
                // Initialize CountUp.js with the provided configuration
                new countUp.CountUp($dom[0], Number(config.endVal), {
                    separator: config.separator,
                    duration: Number(config.duration),
                    decimalPlaces: Number(config.decimalPlaces),
                    startVal: Number(config.startVal),
                }).start();
            }
        });
    },
};

window.stat_card_controller = stat_card_controller;

jQuery(document).ready(function() {
    // Initialize the stat card controller when the document is ready
    stat_card_controller.init();
});